import { cva } from 'class-variance-authority';
export const textStyling = cva('', {
    variants: {
        type: {
            h1: 'text-2xl text-gray-900 font-semibold',
            h2: 'text-xl text-gray-900 font-semibold',
            h3: 'text-lg text-gray-800 font-semibold',
            h4: 'text-base text-gray-800 font-medium',
            h5: 'text-base text-gray-700 font-medium',
            p: 'text-base text-gray-700',
            s: 'text-sm text-gray-700',
            xs: 'text-xs text-gray-700',
            xxs: 'text-[10px] leading-[14px] text-gray-600',
        },
        weight: {
            light: 'font-light',
            normal: 'font-normal',
            medium: 'font-medium',
            semibold: 'font-semibold',
            bold: 'font-bold',
        },
    },
    defaultVariants: {
        type: 'p',
    },
});
